module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.modalId,
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId,
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header text-left"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n          " + _vm._s(_vm.modalState) + "\n        ")])]), _vm._v(" "), (!_vm.combineInfo.length && _vm.state != 1) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-red"
  }, [_vm._v("\n          請新增此商品的組合  •ᴥ•\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.state != 1 && _vm.combineInfo.length) ? _c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._l((_vm.combineInfo), function(combine, index) {
    return _c('li', {
      class: {
        active: _vm.isTabActive(index + 1)
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.clickCombine(combine, index)
        }
      }
    }, [_vm._v(_vm._s(combine.name) + "\n              "), (_vm.state == 3 && !_vm.editState && combine.is_common) ? _c('span', [_vm._v(" "), _c('label', {
      staticClass: "badge bg-blue"
    }, [_vm._v("常見")])]) : _vm._e()])])
  }), _vm._v(" "), (_vm.pageAmount > 1) ? _c('li', {
    staticClass: "pull-right"
  }, [_c('ul', {
    staticClass: "pagination",
    staticStyle: {
      "margin": "0px"
    }
  }, _vm._l((_vm.pageAmount), function(index) {
    return _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getCombineInfo(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])])
  }), 0)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.combineInfo.length) ? _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [(_vm.editState) ? _c('button', {
    staticClass: "btn btn-danger icon-modal-del inherit",
    on: {
      "click": function($event) {
        _vm.show.delNotify = !_vm.show.delNotify
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.editState && _vm.state == 3) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit inherit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clickEdit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary icon-modal-edit inherit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editState = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.delNotify) ? _c('div', {
    staticClass: "del-c-block"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show.delNotify = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delCombine
    }
  }, [_vm._v("刪除")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.page == 1 && _vm.combineInfo.length) ? _c('div', {
    staticClass: "box-body form"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("組合名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.productName))])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.combineDetail.price) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.price) + " (" + _vm._s(_vm.getPriceType(_vm.combineDetail.price_type)) + ")")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.combineDetail.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.description))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.combineDetail.remark) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.remark))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("組合更新時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.update_time))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("組合建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.combineDetail.create_time))])]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.page == 2) ? _c('div', {
    staticClass: "box-body form",
    class: {
      'form-100-p': _vm.page == 2
    }
  }, [_c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, _vm._l((_vm.isAdjust), function(a, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "text-black col-xs-12 block-adjust-title"
    }, [_c('span', {
      staticStyle: {
        "top": "6px"
      }
    }, [_vm._v(_vm._s(a.name) + " "), (a.price) ? _c('span', [_vm._v("$" + _vm._s(a.price))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "text-black col-xs-12"
    }, [_c('span', {
      staticClass: "text-15"
    }, [_vm._v(_vm._s(a.description) + " "), (a.remark) ? _c('span', [_vm._v("(" + _vm._s(a.remark) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-body col-xs-12"
    }, _vm._l((a.option_list), function(o, index) {
      return _c('div', {
        staticClass: "col-xs-6 col-md-3 p-5"
      }, [_c('button', {
        staticClass: "btn-options text-16"
      }, [_vm._v(_vm._s(o.name) + " "), (o.price) ? _c('span', [_vm._v("$" + _vm._s(o.price))]) : _vm._e()])])
    }), 0), _vm._v(" "), _vm._m(3, true)])
  }), 0), _vm._v(" "), (_vm.isOption.length) ? _c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-body col-xs-12"
  }, _vm._l((_vm.isOption), function(o, index) {
    return _c('div', {
      staticClass: "col-xs-6 col-md-3 p-5"
    }, [_c('button', {
      staticClass: "btn-options text-16"
    }, [_vm._v(_vm._s(o.name) + " "), (o.price) ? _c('span', [_vm._v("$" + _vm._s(o.price))]) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(5)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 1 || _vm.editState) ? _c('div', {
    staticClass: "box-body form",
    class: {
      'form-100-p': _vm.page == 2
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page == 1),
      expression: "page == 1"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.name),
      expression: "combineDetail.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.combineDetail.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v(_vm._s(_vm.productName))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.is_common),
      expression: "combineDetail.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.combineDetail.is_common, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.combineDetail, "is_common", "1")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.is_common),
      expression: "combineDetail.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.combineDetail.is_common, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.combineDetail, "is_common", "0")
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格")]), _vm._v(" "), (_vm.state == 1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price),
      expression: "combineDetail.price"
    }],
    ref: "price1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.combineDetail.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "price", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price),
      expression: "combineDetail.price"
    }],
    ref: "price3",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.combineDetail.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "price", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(選取組合內的選項皆為此價格)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價格類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price_type),
      expression: "combineDetail.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.combineDetail, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(若無價格則無須更動)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.remark),
      expression: "combineDetail.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.combineDetail.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page == 2),
      expression: "page == 2"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 text-left p-x-0"
  }, _vm._l((_vm.adjust), function(a, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "text-black col-xs-12 block-adjust-title"
    }, [_c('span', {
      staticStyle: {
        "top": "6px"
      }
    }, [_vm._v(_vm._s(a.name) + "  "), (a.price) ? _c('span', [_vm._v("$ " + _vm._s(a.price))]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default text-15 btn-add-product btn-success m-l-15",
      on: {
        "click": function($event) {
          return _vm.chooseOptionsByAdjust(a)
        }
      }
    }, [_vm._v("全選")]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default text-15 btn-add-product btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeOptionsByAdjust(a)
        }
      }
    }, [_vm._v("全取消")])]), _vm._v(" "), _c('div', {
      staticClass: "text-black col-xs-12"
    }, [_c('span', {
      staticClass: "text-15"
    }, [_vm._v(_vm._s(a.description) + " "), (a.remark) ? _c('span', [_vm._v("(" + _vm._s(a.remark) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-body col-xs-12"
    }, _vm._l((a.option_list), function(o, index) {
      return _c('div', {
        staticClass: "col-xs-6 col-md-3 p-5"
      }, [_c('button', {
        staticClass: "btn-options text-16",
        class: {
          active: o.tag
        }
      }, [_c('span', {
        staticClass: "fake-bg",
        on: {
          "click": function($event) {
            return _vm.chooseOption(o, a)
          }
        }
      }), _vm._v("\n                      " + _vm._s(o.name) + "  "), (o.price) ? _c('span', [_vm._v("$ " + _vm._s(o.price))]) : _vm._e()])])
    }), 0), _vm._v(" "), _vm._m(8, true)])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.state == 3 && !_vm.editState && _vm.page == 1 && _vm.combineInfo.length) ? _c('button', {
    staticClass: "btn btn-primary m-b-15",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.page = 2
      }
    }
  }, [_vm._v("組合內容")]) : _vm._e(), _vm._v(" "), (_vm.state == 3 && !_vm.editState && _vm.page == 2 && _vm.combineInfo.length) ? _c('button', {
    staticClass: "btn btn-primary m-b-15",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.page = 1
      }
    }
  }, [_vm._v("組合明細")]) : _vm._e(), _vm._v(" "), ((_vm.state != 3 || _vm.editState) && _vm.page == 2) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.page = 1
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), ((_vm.state != 3 || _vm.editState) && _vm.page == 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.page = 2
      }
    }
  }, [_vm._v("下一步")]) : _vm._e()])]), _vm._v(" "), (_vm.state != 3 || _vm.editState) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.state == 1 && _vm.page == 2) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.editState) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("編輯")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-left"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('p', [_vm._v("確定刪除此商品？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-black col-xs-12 block-adjust-title"
  }, [_c('span', {
    staticStyle: {
      "top": "6px"
    }
  }, [_vm._v("其他選項")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("組合名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "col-xs-12"
  }, [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45b119c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CombineModal.vue
// module id = 2397
// module chunks = 1